import React from 'react';
import { Mail, Phone, Award } from 'lucide-react';
import { mockData } from '../mockData';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';

const TeamMemberCard = ({ member }) => (
  <Card className="group hover:shadow-2xl transition-all duration-500 border-2 border-transparent hover:border-gold/20 overflow-hidden">
    <div className="relative h-80 overflow-hidden bg-cream">
      <img
        src={member.image}
        alt={member.name}
        className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-navy/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

      <div className="absolute top-4 right-4">
        <Badge className="bg-gold text-navy font-semibold px-4 py-2 text-sm">
          {member.role}
        </Badge>
      </div>
    </div>

    <CardContent className="p-8 space-y-6">
      <div className="space-y-2">
        <h3 className="font-serif text-2xl font-bold text-navy">
          {member.name}
        </h3>
        <div className="flex items-center space-x-2 text-gold">
          <Award className="w-5 h-5" />
          <span className="font-medium">{member.role}</span>
        </div>
      </div>

      <p className="text-navy/70 leading-relaxed">
        {member.bio}
      </p>

      <div className="pt-6 border-t border-navy/10 space-y-3">
        <a
          href={`mailto:${member.email}`}
          className="flex items-center space-x-3 text-navy/70 hover:text-gold transition-colors group/link"
        >
          <div className="w-10 h-10 bg-cream rounded-full flex items-center justify-center group-hover/link:bg-gold/10 transition-colors">
            <Mail className="w-5 h-5" />
          </div>
          <span className="text-sm">{member.email}</span>
        </a>
        <a
          href={`tel:${member.phone.replace(/\s/g, '')}`}
          className="flex items-center space-x-3 text-navy/70 hover:text-gold transition-colors group/link"
        >
          <div className="w-10 h-10 bg-cream rounded-full flex items-center justify-center group-hover/link:bg-gold/10 transition-colors">
            <Phone className="w-5 h-5" />
          </div>
          <span className="text-sm">{member.phone}</span>
        </a>
      </div>
    </CardContent>
  </Card>
);

const Team = () => {
  return (
    <section id="team" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
          <div className="inline-block">
            <span className="text-gold font-semibold text-sm uppercase tracking-wider">
              Nossa Equipa
            </span>
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-navy leading-tight">
            <span className="text-gold">Advogadas</span>
          </h2>
          <p className="text-lg text-navy/70 leading-relaxed">
            Fundadoras do escritório, com formação sólida e compromisso com a excelência no exercício da advocacia.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto">
          {mockData.team.map((member) => (
            <TeamMemberCard key={member.id} member={member} />
          ))}
        </div>

        <div className="mt-16 max-w-4xl mx-auto text-center">
          <div className="bg-gradient-to-r from-cream via-white to-cream p-12 rounded-lg border-2 border-gold/20">
            <p className="text-xl text-navy/80 italic leading-relaxed">
              "O escritório pauta a sua atuação pelo rigor técnico, pela responsabilidade
              e por uma abordagem prática do Direito, ajustada à realidade de cada cliente."
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
